import { instance } from '@/services/avik-api-gateway'
import { VehicleTypeGroup } from '@/types/vehicle-type-group'
import { AxiosResponse } from 'axios'

export function getVehicleTypeGroups(): Promise<
  AxiosResponse<VehicleTypeGroup[]>
> {
  return instance.get(`/vehicle-type-group`)
}
